<template>
  <div class="loading">
    <div class="wrapperL">
      <van-loading size="36px" type="spinner" color="#fff" text-color="#fff" vertical class="loadingS">{{title}}</van-loading>
    </div>
    
  </div>
</template>

<script>
 import {Loading} from 'vant'
export default {
  props: {},
  data() {
    return {
      title: ""
    };
  },
  computed: {
    myValue() {
      return this.$store.state.title;
    },
  },
  // 监听返回
  watch: {
    myValue(newVal) {
      if (newVal) {
        this.title = newVal;
      } else {
        this.title = "加载中..."
      }
    },
  },
  created() {},
  mounted() {
    this.title = this.$store.state.title
  },
  components:{
    [Loading.name]: Loading
  }
};
</script>

<style scoped lang="scss">
.loading {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 99999;
  padding-top: 60%;
  background:rgba(0,0,0,0) ;
}
.wrapperL{
  position: absolute;
  background-color: rgba(0,0,0,0.7);
  width:1.8rem;
  height: 1.2rem;
  border-radius: 0.04rem;
  left:50%;
  top:40%;
  transform: translate(-50%,-50%);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>